import { create } from 'zustand';
import { CurrencyConfig } from '../config/currencyConfig';
import { Currency } from '../types/Currency';
import {
  formatCurrency,
  convertCurrency,
  formatNumber,
  limitDecimals,
} from '../utils/currencyUtils';

interface CurrencyStore {
  currency: Currency;
  formatCurrency: (amount: string, decimalPlace?: number) => string;
  formatBaseCurrency: (amount: string, decimalPlace?: number) => string;
  convertCurrency: (amount: string) => number;
  limitDecimals: (amount: string) => string;
  formatNumber: (amount: string, decimalPlace?: number) => string;
  setCurrency: (currency: Currency) => void;
}

interface CurrencyActions {
  setCurrency: (currency: Currency) => void;
}

export const useCurrencyStore = create<CurrencyStore & CurrencyActions>(
  (set, get) => ({
    currency: new Currency(
      CurrencyConfig.id,
      CurrencyConfig.name,
      CurrencyConfig.code,
      CurrencyConfig.symbol,
      CurrencyConfig.position,
      CurrencyConfig.decimalPlace,
      CurrencyConfig.value
    ),
    setCurrency: (currency: Currency) => set({ currency }),
    formatCurrency: (amount: string, decimalPlace?: number) => {
      const { currency } = get();
      return formatCurrency(amount, currency, decimalPlace);
    },
    formatBaseCurrency: (amount: string, decimalPlace?: number) => {
      const { currency } = get();
      return formatCurrency(amount, currency, decimalPlace, true);
    },
    convertCurrency: (amount: string) => {
      const { currency } = get();
      return convertCurrency(amount, currency);
    },
    limitDecimals: (amount: string) => {
      const { currency } = get();
      return limitDecimals(amount, currency.decimalPlace);
    },
    formatNumber: (amount: string, decimalPlace?: number) => {
      const { currency } = get();
      return formatNumber(amount, currency, decimalPlace);
    },
  })
);
